// extracted by mini-css-extract-plugin
module.exports = {"wrapperItem":"styles_wrapperItem__2dQF5","tableItemName":"styles_tableItemName__wmmvw","tableTitle":"styles_tableTitle__pIi3H","tableItem":"styles_tableItem__ETySx"};